import React from 'react';
import { useCheckoutStore } from '../../store/checkoutStore';
import { useProductStore } from '../../store/productStore';

interface Props {
  onBumpChange: (enabled: boolean) => void;
}

export const BumpOffer = ({ onBumpChange }: Props) => {
  const { currentPage } = useCheckoutStore();
  const getProduct = useProductStore((state) => state.getProduct);
  const bumpProduct = currentPage?.bumpOffer?.productId ? getProduct(currentPage.bumpOffer.productId) : null;

  if (!bumpProduct) return null;

  return (
    <div className="border border-green-200 bg-green-50 rounded-lg p-4 mb-4">
      <div className="flex items-start gap-3">
        <input
          type="checkbox"
          checked={currentPage?.bumpOffer?.enabled || false}
          onChange={(e) => onBumpChange(e.target.checked)}
          className="mt-1"
        />
        <div>
          <h4 className="text-sm font-medium text-green-800">
            Special Offer! Add {bumpProduct.name}
          </h4>
          <p className="text-sm text-green-700 mt-1">
            {bumpProduct.description}
          </p>
          <p className="text-sm font-semibold text-green-800 mt-2">
            Just ₹{bumpProduct.price.toFixed(2)} extra
          </p>
        </div>
      </div>
    </div>
  );
};